import { gql } from "@apollo/client";

export const GET_CLASSES_QUERY = gql`
    query ScheduleClasses(
        $dateFrom: Date!
        $dateUntil: Date!
        $orderBy: String
        $instructor: ID
        $organizationClasstype: ID
        $organizationLevel: ID
        $organizationLocation: ID
    ) {
        scheduleClasses(
            dateFrom: $dateFrom
            dateUntil: $dateUntil
            orderBy: $orderBy
            instructor: $instructor
            organizationClasstype: $organizationClasstype
            organizationLevel: $organizationLevel
            organizationLocation: $organizationLocation
            publicOnly: false
        ) {
            date
            bookingOpenOn
            classes {
                scheduleItemId
                frequencyType
                date
                status
                holiday
                holidayName
                description
                account {
                    id
                    fullName
                }
                role
                account2 {
                    id
                    fullName
                }
                role2
                organizationLocationRoom {
                    id
                    name
                    organizationLocation {
                        id
                        name
                    }
                }
                organizationClasstype {
                    id
                    name
                }
                organizationLevel {
                    id
                    name
                }
                timeStart
                timeEnd
                spaces
                countAttending
                countBooked
                countAttendingAndBooked
                availableSpacesOnline
                availableSpacesTotal
                waitlistEnabled
                waitlistCount
                hasWaitlist
                userWaitlistPosition
                isUserOnWaitlist
                canJoinWaitlist
                userWaitlistAttendanceId
                isBookable
                userBookingStatus
                userAttendanceId
                displayPublic
                bookingStatus
            }
        }
        instructors(first: 100) {
            edges {
                node {
                    id
                    fullName
                }
            }
        }
        organizationLocations(first: 100, archived: false) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                }
            }
        }
        organizationClasstypes(first: 100, archived: false) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                }
            }
        }
        organizationLevels(first: 100, archived: false) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                }
            }
        }
    }
`;

export const GET_CLASS_QUERY = gql`
    query ScheduleItem($id: ID!, $before: String, $after: String) {
        scheduleItem(id: $id) {
            id
            frequencyType
            frequencyInterval
            organizationLocationRoom {
                id
                name
                organizationLocation {
                    id
                    name
                }
            }
            organizationClasstype {
                id
                name
            }
            organizationLevel {
                id
                name
            }
            dateStart
            dateEnd
            timeStart
            timeEnd
            spaces
            walkInSpaces
            displayPublic
            enrollmentSpaces
            infoMailEnabled
            infoMailContent
        }
        organizationLocationRooms(
            first: 100
            before: $before
            after: $after
            archived: false
        ) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                    organizationLocation {
                        id
                        name
                    }
                }
            }
        }
        organizationClasstypes(
            first: 100
            before: $before
            after: $after
            archived: false
        ) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                }
            }
        }
        organizationLevels(
            first: 100
            before: $before
            after: $after
            archived: false
        ) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                }
            }
        }
        financePaymentMethods(
            first: 100
            before: $before
            after: $after
            archived: false
        ) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                }
            }
        }
    }
`;

export const GET_INPUT_VALUES_QUERY = gql`
    query ScheduleClassInputValues($after: String, $before: String) {
        organizationLocationRooms(
            first: 100
            before: $before
            after: $after
            archived: false
        ) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                    organizationLocation {
                        id
                        name
                    }
                }
            }
        }
        organizationClasstypes(
            first: 100
            before: $before
            after: $after
            archived: false
        ) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                }
            }
        }
        organizationLevels(
            first: 100
            before: $before
            after: $after
            archived: false
        ) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                }
            }
        }
        financePaymentMethods(
            first: 100
            before: $before
            after: $after
            archived: false
        ) {
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    id
                    archived
                    name
                }
            }
        }
    }
`;

export const CREATE_CLASS = gql`
    mutation CreateScheduleClass($input: CreateScheduleClassInput!) {
        createScheduleClass(input: $input) {
            scheduleItem {
                id
                scheduleItemType
                frequencyType
                frequencyInterval
                organizationLocationRoom {
                    id
                    name
                    organizationLocation {
                        id
                        name
                    }
                }
                organizationClasstype {
                    id
                    name
                }
                organizationLevel {
                    id
                    name
                }
                dateStart
                dateEnd
                timeStart
                timeEnd
                displayPublic
            }
        }
    }
`;

export const COPY_CLASS = gql`
    mutation CopyScheduleClass($input: CopyScheduleClassInput!) {
        copyScheduleClass(input: $input) {
            scheduleItem {
                id
                scheduleItemType
                frequencyType
                frequencyInterval
                organizationLocationRoom {
                    id
                    name
                    organizationLocation {
                        id
                        name
                    }
                }
                organizationClasstype {
                    id
                    name
                }
                organizationLevel {
                    id
                    name
                }
                dateStart
                dateEnd
                timeStart
                timeEnd
                displayPublic
                spaces
                walkInSpaces
                enrollmentSpaces
                infoMailEnabled
                infoMailContent
            }
        }
    }
`;
